import { useNavigate } from "react-router-dom";

const ecosystems = [
  {
    name: "Rainforest",
    id: "rainforest",
    emoji: "🌳",
    desc: "I breathe for the planet, yet I'm vanishing day by day.",
    color: "bg-green-100",
    gradient: "from-green-100 via-white to-green-200",
  },
  {
    name: "Ocean",
    id: "ocean",
    emoji: "🌊",
    desc: "I hold mysteries and life, but plastic and heat are choking me.",
    color: "bg-blue-100",
    gradient: "from-blue-100 via-white to-blue-200",
  },
  {
    name: "Glacier",
    id: "glacier",
    emoji: "❄️",
    desc: "I was eternal... now I melt into memory.",
    color: "bg-sky-100",
    gradient: "from-sky-100 via-white to-sky-200",
  },
];

function EcosystemSelect() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-green-50 to-white flex flex-col items-center px-4 py-10">
      <h1 className="text-3xl font-bold text-green-900 mb-2 text-center">
        🌍 Choose an Ecosystem to Speak With
      </h1>
      <p className="text-gray-600 text-sm mb-10 text-center max-w-xl">
        Each ecosystem has a voice, a memory, and a message. Who will you listen to?
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-5xl w-full">
        {ecosystems.map((eco) => (
          <div
            key={eco.id}
            onClick={() => navigate(`/chat/${eco.id}`)}
            className={`cursor-pointer rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 bg-gradient-to-br ${eco.gradient}`}
          >
            <div className="text-4xl mb-3">{eco.emoji}</div>
            <h2 className="text-xl font-semibold text-green-800 mb-2">{eco.name}</h2>
            <p className="text-gray-700 text-sm mb-4">{eco.desc}</p>
            <button className="text-green-700 text-sm font-medium hover:underline">
              Learn More →
            </button>
          </div>
        ))}
      </div>

      <button
        onClick={() => navigate("/")}
        className="mt-12 text-sm text-green-700 hover:underline bg-green-100 px-4 py-2 rounded shadow-sm"
      >
        ← Back to Home
      </button>
    </div>
  );
}

export default EcosystemSelect;

